import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import "./colors.scss";

export const customColors = {
    primary: "#ec008c",
    secondary: "#4a148c",
    tertiary: "#fcd13a",
};

// TODO: REMOVE (PROP disableRipple:true on MuiButtonBase AND
//  OVERRIDES (underline on MuiInput, focusVisible on MuiButtonBase)
// WHEN https://bugs.chromium.org/p/chromium/issues/detail?id=992010 fixed

export const muiTheme = createMuiTheme({
    palette: {
        primary: {
            main: customColors.primary,
        },
        secondary: {
            main: customColors.secondary,
        },
        error: {
            main: "#f44336",
        },
    },

    typography: {
        fontFamily: "Swiss-721-Greek-BT",
    },

    props: {
        MuiButtonBase: {
            disableRipple: true,
        },
    },

    overrides: {
        MuiTypography: {
            body1: {
                fontSize: "0.9em",
                fontWeight: 100,
                color: customColors.secondary,
            },
            body2: {
                fontSize: "0.8em",
                fontWeight: 100,
                color: customColors.secondary,
            },
            h1: {
                fontSize: "2.9em",
                fontWeight: 800,
            },
            h2: {
                fontSize: "2em",
                fontWeight: 800,
            },
            h3: {
                fontSize: "1.9em",
                fontWeight: 800,
            },
            h4: {
                fontSize: "1.6em",
                fontWeight: 400,
            },
            h5: {
                fontSize: "1em",
                fontWeight: 400,
            },
            h6: {
                fontSize: 20,
                fontWeight: 500,
                color: "white",
            },
            subtitle1: {
                fontSize: 16,
                fontWeight: 500,
            },
            subtitle2: {
                fontSize: 17,
                fontWeight: 400,
            },
            overline: {
                fontSize: 15,
                fontWeight: 100,
                lineHeight: "18px",
            },
        },
        MuiCardContent: {
            root: {
                padding: "24px",
            },
        },
        MuiButtonBase: {
            root: {
                "&$focusVisible": {
                    outline: "auto 5px -webkit-focus-ring-color !important",
                },
            },
        },
        MuiButton: {
            root: {
                textTransform: "initial",
                borderRadius: "50px",
            },
            contained: {
                boxShadow: "none",
            },
            outlined: {
                boxShadow: "none",
            },
            sizeLarge: {
                padding: "13px 29px",
                fontSize: "0.8em",
                lineHeight: "1.16em",
            },
        },
        MuiStepper: {
            root: {
                padding: "24px 0",
            },
        },
        MuiStepIcon: {
            root: {
                "&$active": {
                    fill: customColors.secondary,
                    "&$text": {
                        fill: customColors.secondary,
                    },
                },
                "&$completed": {
                    fill: customColors.secondary,
                },
                fill: "#B8B9BA",
            },
            text: {
                fill: "white",
            },
        },
        MuiStepLabel: {
            label: {
                color: "#B8B9BA",
                "&$active": {
                    color: customColors.secondary,
                },
                "&$completed": {
                    color: customColors.secondary,
                },
            },
        },
        MuiPaper: {
            rounded: {
                borderRadius: "10px",
            },
            elevation2: {
                boxShadow:
                    "0px 0px 8px 0px rgba(0, 0, 0, 0)," +
                    "0px 0px 4px 0px rgba(0, 0, 0, 0), " +
                    "0px 0px 7px 2px rgba(0, 0, 0, 0.11);",
            },
        },
        MuiMobileStepper: {
            root: {
                backgroundColor: "transparent",
            },
        },
        MuiInput: {
            underline: {
                "&&&&:hover:before": {
                    borderBottom: "1px solid",
                },
            },
        },
        MuiInputBase: {
            root: {
                color: customColors.secondary,
            },
        },
        MuiTableCell: {
            body: {
                fontSize: "initial",
            },
            footer: {
                fontSize: "initial",
            },
        },
        MuiTooltip: {
            tooltip: {
                fontSize: "0.7em",
            },
        },
        MuiFormControlLabel: {
            label: {
                fontSize: "0.8em",
            },
        },
        // @ts-expect-error: Unreachable code error
        MuiPickersDay: {
            day: {
                fontSize: "0.9em",
            },
        },
    },
});
